import React from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';
import FileUpload from 'src/pages/Devices/GroupDetails/TabPages/GroupDesign/components/FileUpload';

import { DrawerContent, DrawerElement, DrawerElementLabel, StyledDrawer } from '../../Assets.styled';
import { FileUploadWrapper, TabPageContentWrapperStyled } from './AssetsList.styled';

interface AssetFormValue {
  id?: string;
  name: string;
  file: string;
  contentType: string;
}

interface AssetsListProps {
  assets: AssetFormValue[];
  onChange: (fileData: File | string | null) => void;
  onRemove: (id: string) => void;
  onDrawerOpen: () => void;
  isDesktop: boolean;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  isDrawerVisible: boolean;
  setDrawerVisible: (open: boolean) => void;
  handleChooseFromLibrary: () => void;
  t: (key: string) => string;
  handleDeleteAsset: (id: string) => void;
  handleSlotChange: (fileData: File | string | null) => void;
  formMethods: UseFormReturn<{ assets: AssetFormValue[] }>;
  onValidateFile?: (fileData: { url?: string; image?: string; name?: string; size?: number | string }) => boolean;
}

const AssetsList: React.FC<AssetsListProps> = ({
  assets,
  onDrawerOpen,
  isDesktop,
  isDrawerVisible,
  setDrawerVisible,
  handleChooseFromLibrary,
  t,
  handleDeleteAsset,
  handleSlotChange,
  formMethods,
  onValidateFile,
}) => (
  <TabPageContentWrapperStyled $isDesktop={isDesktop}>
    {assets.map((asset, idx) => (
      <Controller
        key={`${asset.id || 'new'}-${idx}`}
        name={`assets.${idx}`}
        control={formMethods.control}
        render={({ field }) => {
          const value = field.value.file
            ? {
                url:
                  field.value.contentType && field.value.file
                    ? `data:${field.value.contentType};base64,${field.value.file}`
                    : field.value.file,
                name: field.value.name,
              }
            : undefined;
          return (
            <FileUploadWrapper>
              <FileUpload
                onClick={!isDesktop ? onDrawerOpen : undefined}
                isMobile={!isDesktop}
                onChange={(fileData) => handleSlotChange(fileData as File | null)}
                onRemoveAsset={asset.id && asset.id !== 'loading' ? () => handleDeleteAsset(asset.id!) : undefined}
                accept={'.png,.jpg,.jpeg,.otf,.ttf'}
                maxSizeInMB={1}
                label={t('assets.clickHereOrDragFileToUpload')}
                openFileDialogOnClick={isDesktop}
                onValidateFile={onValidateFile}
                value={value}
              />
            </FileUploadWrapper>
          );
        }}
      />
    ))}
    <StyledDrawer title={t('assets.addFile')} open={isDrawerVisible}>
      <DrawerContent>
        <DrawerElement>
          <DrawerElementLabel onClick={handleChooseFromLibrary}>{t('assets.chooseFromLibrary')}</DrawerElementLabel>
        </DrawerElement>
        <DrawerElement>
          <DrawerElementLabel onClick={() => setDrawerVisible(false)}>{t('general.cancel')}</DrawerElementLabel>
        </DrawerElement>
      </DrawerContent>
    </StyledDrawer>
  </TabPageContentWrapperStyled>
);

export default AssetsList;
